import React from 'react'
import { Button } from '@alifd/next'
import styles from './index.module.scss'
import { training } from 'portal/assets/images'

interface ClinicalStudyProps{
  count: string,
  unit: string,
  event: string,
}
export default function TalentTraining() {
  const trainingMetting: ClinicalStudyProps[] = [
    {
      count: '21',
      unit: '场',
      event: '举办会议',
    },
    {
      count: '20',
      unit: '省',
      event: '覆盖区域',
    },
    {
      count: '476',
      unit: '家',
      event: '纳入医院',
    },
    {
      count: '2,608',
      unit: '位',
      event: '培训学员',
    },
  ]

  const trainingBroadcast: ClinicalStudyProps[] = [
    {
      count: '78',
      unit: '场',
      event: '互动直播',
    },
    {
      count: '178',
      unit: '位',
      event: '邀请专家',
    },
    {
      count: '5,795',
      unit: '人',
      event: '服务医生',
    },
    {
      count: '33,541',
      unit: '次',
      event: '累计观看',
    },
  ]
  
  function leftMetting(props: ClinicalStudyProps) {
    const { count, unit, event } = props
    return (
      <ul data-flex="cross: center">
        <li>
          { count }
          <span>{ unit }</span>
          <p style={{ marginTop: 14, color: '#a1a5b5' }}>{ event }</p>
        </li>
      </ul>
    )
  }

  function rightBroadcast(props: ClinicalStudyProps) {
    const { count, unit, event } = props
    return (
      <ul data-flex="cross: center" key={ event }>
        <li>
          { count }
          <span>{ unit }</span>
          <p style={{ marginTop: 14, color: '#a1a5b5' }}>{ event }</p>
        </li>
      </ul>
    )
  }

  return (
    <React.Fragment>
      {/* 临床研究人才培养 */}
      <div className={ styles.talentTraining }>
        <div className={ styles.training } data-flex="cross: center">
          <div style={{ paddingTop: 90 }}>
            <img style={{ width: 393, height: 436 }} src={ training } alt=""/>
          </div>
          <div style={{ paddingLeft: 97 }}>
            <h2 style={{ color: '#fff', fontSize: 32 }}>临床研究人才培养<p></p></h2>
            <div className={ styles.describe }>充分考虑当前呼吸领域临床研究者的临床研究水平和个性化学习需求，符合呼吸领域临床研究者的在线学习习惯，提供多样化、实用性、系统性、指导性强的临床研究方法学课程，助力临床研究人才队伍的建设</div>
            <div style={{width: 690, paddingTop: 30 }} data-flex="cross: center">
              <div className={ styles.meeting } data-flex="cross: center">
                { trainingMetting.map(leftMetting) }
              </div>
              <div className={ styles.broadcast } data-flex="cross: center">
                { trainingBroadcast.map(rightBroadcast) }
              </div>
            </div>
            <div className={ styles.btn }>
              <a href="/apps/edu" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
                <Button style={{ width: 160, height: 42, fontSize: 14, marginTop: 33, color: '#fff' }}>了解更多培训内容</Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
